<template>
  <div>
    <v-col> <div ref="pieChart"></div></v-col>
    <div style="display: flex; justify-content: flex-end">
      <v-col md="6">
        <v-select
          class="mr-2 pl-100"
          v-model="dataType"
          :items="items"
          outlined
          :label="$t('commons.filters')"
        ></v-select>
      </v-col>
    </div>
  </div>
</template>

<script>
import { makeChartOptions, makeChartObj, updateChartObj } from "@/utils/charts"

export default {
  name: "PieChart",
  props: {
    actions: {
      type: Array
    },
    inspections: {
      type: Array
    },
    nonConformities: {
      type: Array
    }
  },
  data() {
    return {
      chart: null,
      items: ["Inspections status", "Nonconformities status", "Actions type"],
      dataType: "Inspections status"
    }
  },
  computed: {
    isThemeDark() {
      return this.$store.state.app.isThemeDark
    }
  },
  methods: {
    getChartOptions(series, labels) {
      return makeChartOptions({
        chart: {
          type: "pie",
          height: 430,
          offsetY: -10,
          offsetX: 0
        },
        isThemeDark: this.isThemeDark,
        labels: labels,
        series: series,
        titleText: this.dataType
      })
    },
    makeChart() {
      const [series, labels] = this.getSeries()
      const options = this.getChartOptions(series, labels)
      this.chart = makeChartObj(this.$refs.pieChart, options)
    },
    updateChart() {
      const [series, labels] = this.getSeries()
      const options = this.getChartOptions(series, labels)
      updateChartObj(this.chart, options)
    },
    getSeries() {
      switch (this.dataType) {
        case "Inspections status": {
          const inspectionOnGoing = this.inspections.filter(item => item.status == "Ongoing").length
          const inspectionOver = this.inspections.length - inspectionOnGoing
          return [
            [inspectionOver, inspectionOnGoing],
            ["Inspections closed", "Inspections ongoing"]
          ]
        }
        case "Nonconformities status": {
          const ncOnGoing = this.nonConformities.filter(e => e.status == "Ongoing").length
          const ncClosed = this.nonConformities.length - ncOnGoing
          return [
            [ncClosed, ncOnGoing],
            ["Nonconformities closed", "Nonconformities ongoing"]
          ]
        }
        case "Actions type": {
          const actCorrective = this.actions.filter(item => item.type_action == "Corrective").length
          const actPreventive = this.actions.length - actCorrective
          return [
            [actCorrective, actPreventive],
            ["Corrective action", "Preventive action"]
          ]
        }
      }
    }
  },
  mounted() {
    this.makeChart()
  },
  watch: {
    dataType: {
      handler() {
        this.updateChart()
      }
    },
    inspections: {
      handler() {
        this.updateChart()
      }
    },
    isThemeDark: {
      handler() {
        this.updateChart()
      }
    }
  }
}
</script>
